import useCountStProjects from "../../swrCustomHooks/useCountStProjects"
import {useTranslation} from "react-i18next"
import arrowLeftBlackIcon from "../../assets/icon/arrow-left-black.svg"
import arrowLeftGrey from "../../assets/icon/arrow-left-grey.svg"
import arrowRightBlackIcon from "../../assets/icon/arrow-right-black.svg"
import arrowRightGrey from "../../assets/icon/arrow-right-grey.svg"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"

export default function StProjectsFooter() {
    const {t} = useTranslation()
    const {stProjectsContext, setStProjectsAction} = useStProjectsContext()
    const {countStProjects, isLoadingCountStProjects, isErrorCountStProjects} = useCountStProjects(stProjectsContext.tab)
    const options = []

    try {
        var index = 1
        while (index < (Math.ceil(countStProjects / 8) + 1)) {
            options.push({value: index, label: index})
            index++
        }
    } catch {}

    const handlePage = (value) => {
        const selectPage = document.getElementById("selectPage")
        if (value === "-" && stProjectsContext.page > 1) {
            selectPage.value = parseInt(stProjectsContext.page - 1)
            setStProjectsAction({type: "ST_PROJECTS_SET_PAGE", payload: {page: parseInt(stProjectsContext.page) - 1}})
        } else if (value === "+" && stProjectsContext.page < Math.ceil(countStProjects / 8)) {
            selectPage.value = parseInt(stProjectsContext.page + 1)
            setStProjectsAction({type: "ST_PROJECTS_SET_PAGE", payload: {page: parseInt(stProjectsContext.page) + 1}})
        }
    }

    if (isErrorCountStProjects || isLoadingCountStProjects || countStProjects.message || countStProjects <= 8) return null
    return (
        <>
        <div className="SECTION ST-PROJECTS-FOOTER">
            <div className="left-content">
                <select id="selectPage" name="selectPage" onChange={(e) => setStProjectsAction({type: "ST_PROJECTS_SET_PAGE", payload: {page: parseInt(e.target.value)}})}>
                    {options.map((option, index) => {
                        if ((index + 1) === stProjectsContext.page) {
                            return <option selected key={`option-${index}`} value={option.value}>{option.label}</option>
                        } else {
                            return <option key={`option-${index}`} value={option.value}>{option.label}</option>
                        }
                    })}
                </select>
                <p>sur {Math.ceil(countStProjects / 8)} page{Math.ceil(countStProjects / 8) >= 2 && "s"}</p>
            </div>
            <div className="right-content">
                <img src={(Math.ceil(countStProjects / 8) === 1 || stProjectsContext.page === 1) ? arrowLeftGrey : arrowLeftBlackIcon} alt="" onClick={() => handlePage("-")} title={t("Previous page")}/>
                <img src={(Math.ceil(countStProjects / 8) === 1 || stProjectsContext.page === Math.ceil(countStProjects / 8)) ? arrowRightGrey : arrowRightBlackIcon} alt="" onClick={() => handlePage("+")} title={t("Next page")}/>
            </div>
        </div>
        </>
    )
}